export { LeadsRegistryFunnelStageCell } from './ui/LeadsRegistryFunnelStageCell';
